import { useAtticStockMovementListQuery } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import usePaginator, {
  createPaginationState,
  PaginatorContext,
} from "@dashboard/hooks/usePaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";

import AtticLedgerPage from "../components/AtticLedgerPage/AtticLedgerPage";
import {
  atticLedgerUrl,
  type AtticLedgerUrlFilters,
  type AtticLedgerUrlQueryParams,
  parseAtticMovementKind,
} from "../urls";

export const PAGINATE_BY = 50;

export const AtticLedgerView = ({ params }: { params: AtticLedgerUrlQueryParams }) => {
  const navigate = useNavigator();
  const paginationState = createPaginationState(PAGINATE_BY, params);
  const kind = parseAtticMovementKind(params.kind);
  const { data, loading, error } = useAtticStockMovementListQuery({
    displayLoader: true,
    variables: {
      ...paginationState,
      ...(params.sku ? { sku: params.sku } : {}),
      ...(kind ? { kind } : {}),
      ...(params.location ? { location: params.location } : {}),
    },
  });
  const paginationValues = usePaginator({
    pageInfo: data?.atticStockMovements?.pageInfo,
    paginationState,
    queryString: params,
  });
  // A filter change starts over at the first page: the cursor belonged to
  // the old list.
  const changeFilters = (changes: Partial<AtticLedgerUrlFilters>) =>
    navigate(atticLedgerUrl({ ...params, ...changes, after: undefined, before: undefined }));

  return (
    <PaginatorContext.Provider value={paginationValues}>
      <AtticLedgerPage
        movements={
          loading && !data ? undefined : (mapEdgesToItems(data?.atticStockMovements) ?? [])
        }
        loadFailed={!data && !loading && !!error}
        filters={params}
        onFiltersChange={changeFilters}
      />
    </PaginatorContext.Provider>
  );
};

export default AtticLedgerView;
